import { useState } from "react";
import { TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  inputStyles:{
    width: 84,
    height: 84,
    background: "#F2F2F2",
    borderRadius: 10,
    [theme.breakpoints.down("md")]:{
      width: 50,
      height: 50,
    },
    [theme.breakpoints.down("sm")]:{
      width: 40,
      height: 40,
      background: "#D9D9D9",
    },
  },
}));

export default function TextFieldCode({id, handleTextField}){
  
  const classes = useStyles();
  const [value, setValue] = useState("");

  const handleChange = (e) => {
    handleTextField([e.target.name], e.target.value);
    setValue(e.target.value);  
  }

  return(
    <TextField maxLength="1" variant="standard" onChange={handleChange} name={id} type="text" value={value}
      inputProps={{inputMode: 'numeric', pattern: '[0-9]*', maxLength: "1"}}
      InputProps={{
        disableUnderline: true,
        classes: { root: classes.inputStyles },
        sx: { fontSize: {xs: "1rem", md:"2.5rem"},
        "& .MuiInputBase-input": {
            textAlign: "center",
          },  
        },
      }}
    />
  );  
}